import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { JourneyType, SearchFormInputs } from "../../constants";
import JourneyDetails from "./JourneyDetails";

export type JourneyDetailsLoaderData = {
  journeySearchData: JourneyType & { _session?: { startedAt: number; maxTime: number } };
  searchObject: SearchFormInputs;
};

export default function JourneyDetailsLoader() {
  const { ticketId, searchId } = useParams();

  const data = useMemo<JourneyDetailsLoaderData | null>(() => {
    const ticketDataString = localStorage.getItem(`${ticketId}`);
    const searchValuesString = localStorage.getItem(`${searchId}`);
    if (!ticketDataString || !searchValuesString) return null;

    try {
      return {
        journeySearchData: JSON.parse(ticketDataString),
        searchObject: JSON.parse(searchValuesString),
      };
    } catch {
      return null;
    }
  }, [ticketId, searchId]);

  if (!data) return <Navigate to="/not-found" replace />;
  return <JourneyDetails {...data} />;
}
